import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Shanta Equity\\components\\InnerBanner.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Shanta Equity\\components\\transaction\\TransactionList.jsx");
